/**
 * @name Utils
 * @description custom library in ES6
 * @see {@link https://underscorejs.org}
 */
class Utils {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static get = (obj: any, path: string, defaultValue?: any) => {
    const travel = (regexp: RegExp) =>
      String.prototype.split
        .call(path, regexp)
        .filter(Boolean)
        .reduce(
          (res, key) => (res !== null && res !== undefined ? res[key] : res),
          obj
        )
    const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/)
    return result === undefined || result === obj ? defaultValue : result
  }
}

export default Utils
